module.exports = __webpack_public_path__ + "static/media/19.ce7f85db.jpg";